import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { vacationsApi, VacationsResponse } from 'app/services/edpApiV1/vacations';

const initialState: VacationsResponse = {
  data: null,
  pagination: null,
};

export const vacationsSlice = createSlice({
  name: 'vacations',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addMatcher(
        vacationsApi.endpoints.vacations.matchFulfilled,
        (state, { payload }: PayloadAction<VacationsResponse>) => payload,
      )
      .addMatcher(vacationsApi.endpoints.vacations.matchRejected, () => initialState);
  },
});

const vacations = (state: RootState) => state.entities.vacations;
const getVacations = createSelector(vacations, state => state);

export const selectors = { getVacations };
export const actions = vacationsSlice.actions;
export const reducer = vacationsSlice.reducer;
